<script setup lang="ts">
// @ts-nocheck
import { openCountries as countries } from '@design-system/configs/countries'
import type { SubHome } from '@design-system/components/Header/HeaderMonoGram.props'

await nextTick()

useAppConfig().website = window && window?.YEXT ? 'global' : 'giorgio-armani'

const { currentWebsite } = useWebsite()
const { countryLocale, country, locale, isSetup } = useCountryLocale()
const { isLoggedFederated } = useLogin()
const appConfig = useAppConfig()
// setting app config
appConfig.currentLanguage = locale.value
appConfig.currentCountry = country.value
appConfig.currentLanguageCountry = `${locale.value}-${country.value}`

const { $loadTranslations } = useNuxtApp()
// @ts-ignore
await $loadTranslations(countryLocale.value)
const { data: items } = await useMarketingStrip(
  `${currentWebsite.value}-marketing-strips`
)

const hasReadyEventTriggered = useState('readyEventTriggered', () => false)

// send event
const { eventBus } = useFederatedEventBus()
if (!hasReadyEventTriggered.value) {
  const { data } = await useFetch('/api/auth0/getUserMetadata')
  let user = undefined
  if (data.value) {
    user = {
      firstName: data.value.given_name,
      lastName: data.value.family_name,
      email: data.value.email,
    }
    isLoggedFederated.value = true
  }
  hasReadyEventTriggered.value = true
  eventBus?.$emit('readyEvent', {
    language: appConfig.currentLanguage,
    country: appConfig.currentCountry,
    user,
  })
  // first setup has been done, from now on appConfig wins!
  isSetup.value = true
}

const messages = computed(() => items.value?.content?.messages ?? [])
const { menuStatus } = useMenu()
const { internalBrandSortedList } = await useBrandsSettings()

const { data: menuLists, refresh } = await useHeaderConfig(
  currentWebsite,
  countryLocale
)

watch(
  countryLocale,
  (v, oldv) => {
    if (v !== oldv) {
      refresh()
    }
  },
  {
    immediate: true,
  }
)

const topHeader = ref<HTMLElement>()
const localePath = useLocalePath()

const subHome: SubHome[] = internalBrandSortedList.value
  .filter(brand => brand.name !== 'Global' && brand.monogram)
  .map(brand => {
    return {
      to: localePath(`/${convertStringToSlug(brand.name)}/experience`),
      icon: convertStringToSlug(brand.name) as LogoType,
    }
  })

const { isPinned, setIsPinned } = useDefaultHeaderConfig()
</script>

<template>
  <div>
    <div ref="topHeader" class="top-header">
      <HeaderStripWrapper :is-hidden="menuStatus?.isActive">
        <MarketingStrip :messages="messages" />
        <HeaderMonoGram :sub-home="subHome" />
      </HeaderStripWrapper>
    </div>

    <HeaderDefault
      :current-brand="currentWebsite"
      :deferred-current-brand="currentWebsite"
      :is-pinned="isPinned"
      :menu-lists="menuLists ?? []"
      :has-megalogo="false"
      :is-transparent="false"
      :is-federated-app="true"
      @is-pinned-handler="setIsPinned"
    />
    <HeaderNavigationBar anatomy="hp" :is-federated-app="true" />
    <FooterAsideLanguage v-bind="{ countries }" />
  </div>
</template>
<style>
#onetrust-consent-sdk {
  display: none;
}
</style>
